import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import http from '../config/http-service';

export interface ICrmSupplierContactQuotaStatsData {
  totalQuotas: number;
  totalAllocated: number;
  totalUsed: number;
  totalRemaining: number;
  overallUsagePercentage: string;
  averageQuotaPerSupplier: string;
  message: string;
}

const endpoint = 'ums/v1/crm/management/suppliers/contact-quotas/stats/overview';
export const getCrmSupplierContactQuotaStatsEndpointIdentifier = endpoint;

type TData = ICrmSupplierContactQuotaStatsData;
type TError = AxiosError;
type TQueryKey = [typeof endpoint];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetCrmSupplierContactQuotaStatsApi(options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();

  const queryKey: TQueryKey = [endpoint];

  const queryFn = async (): Promise<TData> => {
    const { data } = await http.get(endpoint);
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    ...options,
  });
}
